export default function getFormattedDateRange(
  low?: number | null,
  high?: number | null,
  durationType: string = "hours per week",
) {
  if (low && high) return `${low}-${high} ${durationType}`;
  if (low || high) return `${low || high} ${durationType}`;
  return "";
}
